export function requireAuth(store) {
    return (nextState, replace) => {
        const state = store.getState();
        const user = state.session ? state.session.user : null;
        if( ! user) {
            replace('/login');
        }
        return true;
    }
}

export function onlyGuest(store) {
    return (nextState, replace) => {
        const state = store.getState();
        const user = state.session ? state.session.user : null;
        if(user) {
            replace('/');
        }
        return true;
    }
}


/** WEBPACK FOOTER **
 ** ./src/utils/routing-hooks.js
 **/